import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { AppHeader, useCoreAdapters } from '@liefersoft/pos-ui-core'
import { PageHeaderAnchor } from './index.styled'
import { theme } from '../../style/theme'
import { useWindowBreakPoint } from '../../hooks/useWindowBreakPoint'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import LayoutMode from '../LayoutMode'
import Language from '../Language'
import { setMapHeightHeader } from '../../redux/action/map'
import { selectIsNewsAutoOpenAllowed } from '../../redux/selector/news'

const Header = React.memo(({ children, right, showLayoutMode = false }) => {
	const { i18n } = useTranslation()
	const dispatch = useDispatch()
	const isTablet = useWindowBreakPoint(theme.point820)
	const anchorRef = useRef(null)
	const [touchPad, setTouchPad] = useLocalStorage('touchPad', false)
	const { router } = useCoreAdapters()
	const canAutoOpenNews = useSelector(selectIsNewsAutoOpenAllowed(router.currentPathname))

	useEffect(() => {
		if (isTablet && !touchPad) {
			setTouchPad(true)
		}
	}, [isTablet, touchPad]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const node = anchorRef.current?.firstElementChild

		if (!node) {
			return undefined
		}

		const measure = () => {
			const { offsetHeight } = node

			if (offsetHeight) {
				dispatch(setMapHeightHeader(offsetHeight))
			}
		}
		const observer = new ResizeObserver(measure)

		observer.observe(node)
		measure()

		return () => observer.disconnect()
	}, [dispatch])

	return (
		<PageHeaderAnchor ref={anchorRef}>
			<AppHeader locale={i18n.language} canAutoOpenNews={canAutoOpenNews} right={
				<>
					{right}
					{showLayoutMode && !isTablet && <LayoutMode />}
					{!isTablet && <Language />}
				</>
			}>
				{children}
			</AppHeader>
		</PageHeaderAnchor>
	)
})

Header.displayName = 'Header'
export default Header
